import { render, staticRenderFns } from "./WorkDays.vue?vue&type=template&id=ee5e0534&scoped=true&"
import script from "./WorkDays.vue?vue&type=script&lang=js&"
export * from "./WorkDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5e0534",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee5e0534')) {
      api.createRecord('ee5e0534', component.options)
    } else {
      api.reload('ee5e0534', component.options)
    }
    module.hot.accept("./WorkDays.vue?vue&type=template&id=ee5e0534&scoped=true&", function () {
      api.rerender('ee5e0534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Work/WorkDays.vue"
export default component.exports